import { formatNumberWithCommas } from "../../../../helpers";
import primaryComponents from "../../../primaryComponents";
import { usePlatformCreditTopup } from "./usePlatformCreditTopup";
import useValidation from "./useValidation";

export const PlatformCreditTopup = () => {
  const { isLoading, formData, setFormData, handleTopUp } =
    usePlatformCreditTopup();
  const {
    control,
    trigger,
    formState: { errors },
    handleSubmit,
  } = useValidation({ ...formData });

  return (
    <form onSubmit={handleSubmit(handleTopUp)}>
      <primaryComponents.AmountFieldV2
        control={control}
        name="amount"
        label="Amount"
        placeholder="Enter amount"
        classNames="white"
        isRequired
        value={formData?.amount}
        onChange={({ target: { value } }) => {
          setFormData((prev) => ({ ...prev, amount: value }));
        }}
        errorMessage={errors.amount}
        onKeyUp={() => errors.amount !== undefined && trigger("amount")}
      />

      <div className="d-flex justify-content-between">
        <p>Credit Equivalent</p>
        <h5>{formatNumberWithCommas(formData?.amount)}</h5>
      </div>

      <primaryComponents.Button
        classNames={"btn btn--primary w-100 mt-4"}
        type="submit"
        isDisabled={isLoading}
        isLoading={isLoading}
        loadingText={"Processing..."}
      >
        Top-up
      </primaryComponents.Button>
    </form>
  );
};
